import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './SegmentedControl.module.css';
import type { SegmentedControlProps, SegmentedControlButtonProps } from './types';
import { Fieldset } from '../Fieldset';
function SegmentedControl({
  children,
  layout = 'horizontal',
  className,
  shouldWrap,
  containerClassName,
  ...props
}: SegmentedControlProps) {
  return <Fieldset {...props} className={classNames(containerClassName, {
    [styles.container!]: shouldWrap
  })} layout={layout} layoutProps={{
    className: classNames(styles.group, className, {
      [styles.stack!]: layout === 'vertical',
      [styles.cluster!]: layout === 'horizontal'
    }),
    space: '100'
  }}>
      {children}
    </Fieldset>;
}
function SegmentedControlButton(t0) {
  const $ = _c(18);
  let children;
  let id;
  let labelProps;
  let name;
  let props;
  if ($[0] !== t0) {
    const {
      id: t1,
      name: t2,
      children: t3,
      size,
      labelProps: t4,
      ...t5
    } = t0;
    id = t1;
    name = t2;
    children = t3;
    labelProps = t4;
    props = t5;
    $[0] = t0;
    $[1] = children;
    $[2] = id;
    $[3] = labelProps;
    $[4] = name;
    $[5] = props;
  } else {
    children = $[1];
    id = $[2];
    labelProps = $[3];
    name = $[4];
    props = $[5];
  }
  const t1 = labelProps?.className;
  let t2;
  if ($[6] !== t1) {
    t2 = classNames(styles.button, t1);
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== id || $[9] !== name || $[10] !== props) {
    t3 = <input {...props} type="radio" id={id} name={name} className={styles.hiddenInput} />;
    $[8] = id;
    $[9] = name;
    $[10] = props;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children || $[13] !== id || $[14] !== labelProps || $[15] !== t2 || $[16] !== t3) {
    t4 = <label {...labelProps} htmlFor={id} className={t2}>{t3}{children}</label>;
    $[12] = children;
    $[13] = id;
    $[14] = labelProps;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
SegmentedControl.Item = SegmentedControlButton;
export default SegmentedControl;